import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useGiftsConfig } from './GiftsConfigContext'
import styles from './GiftsSubNav.module.scss'

function GiftsSubNav({ links = [] }) {
  const { pathname } = useLocation()
  const { isDirty } = useGiftsConfig()

  const onNavigate = (path) => (event) => {
    if (pathname === path || pathname.startsWith(`${path}/`)) {
      event.preventDefault()
      return
    }

    if (!isDirty) {
      return
    }

    const confirmed = window.confirm('Є незбережені зміни. Залишити сторінку без збереження?')
    if (!confirmed) {
      event.preventDefault()
    }
  }

  return (
    <nav className={styles.nav} aria-label="Розділи подарунків">
      {links.map((link) => {
        const isActive = pathname === link.path || pathname.startsWith(`${link.path}/`)

        return (
          <Link
            key={link.path}
            to={link.path}
            className={[styles.link, isActive ? styles.linkActive : ''].filter(Boolean).join(' ')}
            onClick={onNavigate(link.path)}
          >
            {link.title}
          </Link>
        )
      })}
    </nav>
  )
}

export default GiftsSubNav
